import { z } from 'zod/v3';

import type { ListUsersParams } from '@/api/generated/model';

export const userRoles = ['admin', 'approver'] as const;

export const roleFilterValues = ['all', ...userRoles] as const;

const baseUsersSearchSchema = z.object({
	page: z.coerce.number().int().positive().default(1),
	perPage: z.coerce.number().int().positive().max(100).default(10),
	role: z.enum(roleFilterValues).default('all'),
});

const drawerSearchStateSchema = z.union([
	z.object({
		mode: z.literal('create'),
		userId: z.undefined().optional(),
	}),
	z.object({
		mode: z.literal('edit'),
		userId: z.string().min(1),
	}),
	z.object({
		mode: z.undefined().optional(),
		userId: z.undefined().optional(),
	}),
]);

export const usersSearchSchema = baseUsersSearchSchema.and(drawerSearchStateSchema);

export type UsersSearch = z.infer<typeof usersSearchSchema>;

export function toListUsersParams(search: UsersSearch): ListUsersParams {
	return {
		page: search.page,
		per_page: search.perPage,
		role: search.role === 'all' ? undefined : search.role,
	};
}
